module.exports = __webpack_public_path__ + "static/media/icon-kettlebell.b4be79bc.svg";